@include component-spacing-and-grid;

:host {
    display: block;

    .headline {
        @include typo-ws-h2;

        margin: 0;
        grid-row: 1;
        grid-column: 2 / span 7;
    }

    .content {
        grid-column: 2 / span 7;
        grid-row: 2;
    }

    slot[name='buttons'] {
        display: block;
        grid-column: 2 / span 12;
        grid-row: 3;
    }

    .image-wrapper {
        display: block;
        grid-column: 9 / -1;
        grid-row: 1 / 4;
        overflow: hidden;
        padding-top: 56%;
        position: relative;
        align-self: flex-start;
    }

    slot[name='picture'] {
        display: block;
        width: 100%;
        height: 100%;
        left: 0;
        position: absolute;
        top: 0;
    }

    ::slotted(sew-picture) {
        width: 100%;
        height: 100%;
    }

    ::slotted(sew-ws-richtext) {
        margin: 32px 0 0;
    }

    .subline {
        @include typo-ws-h4;

        margin: 48px 0 32px;
    }

    ::slotted(sew-ws-button:first-of-type) {
        margin-right: 20px;
    }
}

@include mq-4-min {
    :host {
        .image-wrapper {
            grid-area: 1 / 9 / 4 / -2;
        }
    }
}

@include mq-1 {
    :host {
        .headline {
            grid-column: 2 / -2;
        }

        .content {
            grid-column: 2 / -2;
            grid-row: 3;
        }

        slot[name='buttons'] {
            grid-column: 2 / -2;
            grid-row: 4;
        }

        ::slotted(sew-ws-richtext) {
            margin-top: 24px;
        }

        .image-wrapper {
            grid-column: 2 / -2;
            grid-row: 2;
            position: relative;
            margin-top: 24px;
        }

        .subline {
            margin: 40px 0 32px;
        }

        ::slotted(sew-ws-button) {
            margin-bottom: 0;
            margin-top: 24px;
        }

        ::slotted(sew-ws-button:first-of-type) {
            margin: 0;
        }
    }
}
